import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { DialogContent, Slide } from "@material-ui/core";
import * as Icons from 'react-bootstrap-icons';
import loader from 'Assets/LottieLoader/loader.json';
import Lottie from "lottie-react";
import Translator from "Languages/Utility/Translator";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function LoadOnConvertUnit({show, updateList}) {
    const { direction } = useTheme();
    const [percent, setPercent] = useState(0);
    useEffect(() => {
        let l = updateList.length;
        let ok_status = 0;
        updateList.map(items => {
            if(items.type === 'OK')
                ok_status++;
        })
        setPercent(Math.floor((ok_status*100)/l));

    },[updateList])
    function ItemList({id, name, type}) {
        return(
            <div key={'list-item-inner' + id} className="list-inner">
                <strong>{name}</strong>
                {type === 'OK'&& <Icons.CheckSquareFill color="Green" className="mr-2" size={18}/>}
                {type === 'NO'&& <Icons.DashSquareFill color="Red" className="mr-2" size={18}/>}
                {type === 'PEN'&& <Icons.CloudUploadFill color="Orange" className="mr-2" size={18}/>}
            </div>
        )
    }
    function ItemListSection({title, status}) {
        return(
            <div className="list-convert-unit">
                <div key={`info-${title}`} className="title">
                    <strong>{title}</strong>
                </div>
                {
                    updateList.filter(item => item.type === status).map(items => {
                        return <ItemList id={items.id} name={items.name} type={items.type} />
                    })
                }
            </div>
        )
    }
    return (
        <Dialog
            dir={direction}
            fullWidth
            open={show}
            TransitionComponent={Transition}
            maxWidth="sm"
        >
            <DialogContent>
                <div className="convert-unit-load">
                    <Lottie animationData={loader} loop={true} style={{'width':'150px'}} />
                    <div className="head">
                        <Translator id={'pleaseWaitDesignMode'} noSpan/>
                        <p className="m-0 mr-2">{percent}%</p>
                    </div>
                    <div className="complex-unit-list">
                        <ItemListSection title={'تکمیل شده'} status={'OK'} />
                        <ItemListSection title={'در حال پردازش'} status={'PEN'} />
                        <ItemListSection title={'تکمیل نشده'} status={'NO'} />
                    </div>

                </div>
            </DialogContent>
        </Dialog>
    );
}
